
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/webinarsSchedule",
      function () {
        return require("private-next-pages/[lang]/webinarsSchedule/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/webinarsSchedule"])
      });
    }
  